import NotificacionNoneIcon from "../../../assets/images/generico/NotificacionNoneIcon";
import { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import "./Notifications.css";
import { ContainerNoti } from "./localStyle";
import NotifiacionIcon from "../../../assets/images/generico/NotificacionIcon";
import { useState } from "react";
import CruzIcon from "../../../assets/images/generico/CruzIcon";
import { wsGetNotificacion, wsPutNotiVisto } from "../../../context/Actions/notificaciones/notificaciones";
import { useEffect, useCallback } from "react";
import parse from "html-react-parser";
import { useHistory } from "react-router-dom";

const getNotificationsInterval = 30000;
const markAsReadTimeout = 2000;

const Notifications = () => {
  const history = useHistory();
  const { notificacionesDispatch, notificacionesState, } = useContext(PortalContext);
  const [showNotificationList, setShowNotificationList] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadedNotifications, setUnreadedNotifications] = useState([]);

  const onGetNotifications = useCallback(() => {
    wsGetNotificacion()(notificacionesDispatch);
  }, [notificacionesDispatch]);

  const onMarkAsRead = useCallback((notificacion) => {
    if (!notificacion.leida) {
      wsPutNotiVisto(notificacion.id, onGetNotifications)(notificacionesDispatch);
    }
  }, [notificacionesDispatch, onGetNotifications]);


  const onHandleClickNotifications = () => {
    if (!showNotificationList) {
      setShowNotificationList(true);
    } else {
      setShowNotificationList(false);
    }
  };

  const onHandleClickNotification = (notificacion) => {
    onMarkAsRead(notificacion);
    history.push(notificacion.link.url);
    setShowNotificationList(false);
  }

  let markAsReadTimeoutSubscription = null;
  let getNotificationsIntervalSubscription = null;

  const onEnterNotification = (notificacion) => {
    markAsReadTimeoutSubscription = setTimeout(() => {
      onMarkAsRead(notificacion);
    }, markAsReadTimeout);
  }

  const onLeaveNotification = (notificacion) => {
    clearTimeout(markAsReadTimeoutSubscription);
  }

  let config = localStorage.getItem("config");
  let opcNotificaciones = JSON.parse(config).opcNotificaciones;

  useEffect(() => {
    if (opcNotificaciones) {
      onGetNotifications()
      getNotificationsIntervalSubscription = setInterval(() => onGetNotifications(), getNotificationsInterval);
      return () => clearInterval(getNotificationsIntervalSubscription);
    }
  }, []);

  useEffect(() => {
    if (!notificacionesState?.notificaciones?.loading) {
      setNotifications(notificacionesState?.notificaciones?.data || []);
    }
  }, [notificacionesState?.notificaciones]);

  useEffect(() => {
    setUnreadedNotifications(notifications?.filter((element) => !element.leida) || []);
  }, [notifications]);

  return (
    <>
      <div
        className={`notifications-background ${!showNotificationList ? "disable" : ""}`}
        onClick={onHandleClickNotifications}
      ></div>
      {opcNotificaciones && <ContainerNoti>
        <div className="notification-trigger" onClick={onHandleClickNotifications}>
          {unreadedNotifications.length === 0 && <NotificacionNoneIcon color="#fff" />}
          {unreadedNotifications.length > 0 && <>
            <NotifiacionIcon color="#fff" />
            <div className="number-circle">
              {unreadedNotifications.length}
            </div>
          </>}

          <div className={`notifications-sidebar ${showNotificationList ? "open" : "closed"}`}>
            <div className="notifications-container">
              <div className="header">
                <div className="title">Notificaciones</div>
                <div className="icon">
                  <CruzIcon color="#fff" onClick={onHandleClickNotifications} />
                </div>
              </div>
              <hr className="divider" />
              <div className="list">
                {notifications.map(n =>
                  <div key={n.id} className={`notification ${n.leida ? "" : "unread"}`}
                    onClick={() => onHandleClickNotification(n)}
                    onMouseEnter={() => onEnterNotification(n)}
                    onMouseLeave={() => onLeaveNotification(n)}
                    onTouchStart={() => onEnterNotification(n)}
                    onTouchEnd={() => onLeaveNotification(n)}>
                    <span className="date">{n.fecha}</span>
                    <span className="description">{parse(n.descripcion)}</span>
                  </div>
                )}
              </div>
            </div>
          </div >
        </div>
      </ContainerNoti>
      }
    </>
  )
};

export default Notifications;